import { Box, FormControl } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { fetchRecordsUIDsByTemplateId } from '../../services/entityInstanceServices'
import SearchInAPIAndMultiSelectInput, {
    SelectItem,
} from '../Common/SearchInAPIAndMultiSelectInput'
import { fetchDisplayableLabels } from '../../services/entityServices'

interface UserGroupRecordsSelectProps {
    label: string
    id: string
    value: any
    onChange: any
    templateId: string
    orgId: string
    disabled: boolean
}

const UserGroupRecordsSelect = (
    props: UserGroupRecordsSelectProps,
): ReactElement => {
    const { label, id, value, disabled, onChange, templateId, orgId } = props

    const [recordsList, setRecordsList] = useState<SelectItem[]>([])

    const [selectedValues, setSelectedValues] = useState<any[]>([]) // this for multi select

    const [searchText, setSearchText] = useState<string>('')

    const [pageNumber, setPageNumber] = useState<number>(1)

    const [hasMore, setHasmore] = useState<boolean>(false)

    const [isFetching, setIsFetching] = useState(false)

    useEffect(() => {
        const handleUpdateValue = async () => {
            const displayNamesForValues = await fetchDisplayableLabels(
                orgId,
                value,
            )
            setSelectedValues(displayNamesForValues as any[])
        }

        if (value) {
            handleUpdateValue()
        } else {
            setSelectedValues([])
        }
    }, [value, orgId])

    useEffect(() => {
        if (templateId && orgId) {
            setIsFetching(pageNumber === 1)
            const getRecords = async () => {
                const queryParams = {
                    pageNumber,
                    pageSize: 30,
                    searchText: searchText?.trim(),
                    filterBy: 'ACTIVE',
                    shipmentStatusFilter: '',
                    includeUseOnly: true,
                    includeCommonOrg: true,
                }
                try {
                    const records = await fetchRecordsUIDsByTemplateId(
                        orgId,
                        templateId,
                        queryParams,
                    )
                    const updatedRecords = (records?.data || []) as SelectItem[]
                    setRecordsList((prev) =>
                        pageNumber === 1
                            ? updatedRecords
                            : [...prev, ...updatedRecords],
                    )
                    setHasmore(updatedRecords?.length === 30)
                } finally {
                    setIsFetching(false)
                }
            }
            getRecords()
        }
    }, [templateId, orgId, pageNumber, searchText])

    const onSearch = (id: string, text: any) => {
        setSearchText(text)
        setPageNumber(1)
    }

    const handleFetchNextPage = () => {
        if (!isFetching && hasMore) {
            setPageNumber((prev) => prev + 1)
        }
    }

    const onChangeRecord = (id: string, selectedList: any[] | null) => {
        setSelectedValues(selectedList || [])
        // need to send Ids only to API. while getting also will get only ids. we have saparate API to get labels for selected values
        onChange(id, selectedList?.map((item: any) => item.entityId) || [])
    }

    return (
        <Box>
            <Box>
                <FormControl fullWidth>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Box
                            sx={{
                                width: ' 100%',
                                maxWidth: `100%`,
                            }}
                        >
                            <SearchInAPIAndMultiSelectInput
                                id={id}
                                label={label}
                                // placeholder={t('selectLabel', { label })}
                                isLegend={true}
                                // required={required}
                                value={selectedValues}
                                onSelect={onChangeRecord}
                                disabled={disabled}
                                list={recordsList || []}
                                onSearch={onSearch}
                                onFetchNextPage={handleFetchNextPage}
                                hasMore={hasMore}
                                isFetching={isFetching}
                                itemId="entityId"
                                itemName="uid"
                            />
                        </Box>
                    </Box>
                </FormControl>
            </Box>
        </Box>
    )
}

export default UserGroupRecordsSelect
